import { Component } from '@angular/core';
import { OrdersModule } from '../../../../orders/orders.module';
import { LayoutModule } from '../../../layout/layout.module';

@Component({
  selector: 'app-order-view-dashboard-page',
  standalone: true,
  imports: [LayoutModule, OrdersModule],
  templateUrl: './order-view-dashboard-page.component.html',
})
export class OrderViewDashboardPageComponent { }
